import React from "react";
import { useParams } from "react-router-dom";

const Page = () => {
  const { id } = useParams();

  return (
    <div className="page">
      <h1>
        Page
        {id}
        &nbsp;
      </h1>
    </div>
  );
};

export default Page;
